<template>
  <div class="home" style="padding-bottom: 50px">
    <div
      class="head1"
      :class="{
        'blue-text': parentData.length === 7,
        'green-text': parentData.length === 8,
      }"
    >
      {{ parentData }}
    </div>
    <div class="content">
      <div class="con_head">
        <div
          :class="['car', actives == 1 ? 'actives' : '']"
          @click="oncarShow(1)"
          style="border-radius: 6px 0 0 6px"
        >
          普通车牌
        </div>
        <div
          :class="['car', actives == 2 ? 'actives' : '']"
          @click="oncarShow(2)"
          style="border-radius: 0 6px 6px 0"
        >
          新能源车
        </div>
        <!-- <div
          :class="['car', actives == 3 ? 'actives' : '']"
          @click="oncarShow(3)"
        >
          中大型车
        </div>
        <div
          :class="['car', actives == 4 ? 'actives' : '']"
          @click="oncarShow(4)"
        >
          港/澳车牌
        </div> -->
      </div>
      <!-- 车牌输入 -->
      <div style="margin-top: 20px">
        <carNums
          :cartype="cartype"
          @child-event="handleChildData"
          :car="catnum"
        />
      </div>

      <!-- 历史搜索 -->
      <div style="padding: 15px; margin-top: 30px">
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <div>历史搜索</div>
          <img
            style="width: 20px; height: 20px"
            src="../../assets/del.png"
            alt=""
            @click="onDelete"
          />
        </div>
        <div style="margin-top: 20px; display: flex; flex-wrap: wrap">
          <span
            v-for="(item, index) in historyList"
            :key="index"
            style="
              font-size: 14px;
              padding: 4px 10px;
              background-color: #f1f1f1;
              margin-right: 5px;
              border-radius: 50px;
              display: block;
              margin-bottom: 10px;
            "
            @click="onlist(item.plateNumber)"
            >{{ item.plateNumber }}</span
          >
        </div>
        <div style="text-align: center" v-if="historyList.length == 0">
          暂无历史记录！
        </div>
      </div>
    </div>
    <div
      style="
        background-color: #0095fd;
        width: 80%;
        margin: 0 auto;
        height: 50px;
        border-radius: 5px;
        text-align: center;
        line-height: 50px;
        color: #fff;
        font-size: 20px;
        margin-top: 20px;
      "
      @click="onquery"
    >
      查询
    </div>
    <div v-if="!carShow && imgList.length > 0">
      <!-- 预警 -->
      <div style="background-color: #fff; padding: 10px; margin-top: 20px">
        <div class="plic_list" v-if="nums.warningType">
          <div style="width: 80px">预警类型</div>
          <div style="flex: 1; text-align: right">{{ nums.warningType }}</div>
        </div>
        <div class="plic_list" v-if="nums.verifyStatus == 0">
          <div style="width: 80px">核实状态</div>
          <div style="flex: 1; text-align: right">未核实</div>
        </div>
        <div class="plic_list" v-if="nums.verifyStatus == 1">
          <div style="width: 80px">核实状态</div>
          <div style="flex: 1; text-align: right">已核实</div>
        </div>
        <div class="plic_list">
          <div style="width: 80px" v-if="nums.entryTime">入场时间</div>
          <div style="flex: 1; text-align: right">
            {{ handleTime(nums.entryTime) }}
          </div>
        </div>
        <div class="plic_list" v-if="nums.exitTime">
          <div style="width: 80px">出场时间</div>
          <div style="flex: 1; text-align: right">
            {{ handleTime(nums.exitTime) }}
          </div>
        </div>
        <div class="plic_list" v-if="nums.stayDuration">
          <div style="width: 80px">停留时长</div>
          <div style="flex: 1; text-align: right">
            {{ nums.stayDuration }}分钟
          </div>
        </div>
        <div class="plic_list" v-if="imgList.length > 0">
          <div style="width: 80px">车辆轨迹</div>
          <div style="flex: 1; text-align: right">
            <span v-for="(item, index) in imgList" :key="index">
              {{ item.location
              }}<span v-if="index !== imgList.length - 1"> - </span>
            </span>
          </div>
        </div>
      </div>
      <!-- img -->
      <div
        v-if="imgList.length > 0"
        style="background-color: #fff; padding: 10px; margin-top: 20px"
      >
        <div v-if="nums.id">
          <div v-if="imgList[0]">
            <div class="plic_list">
              <div>
                {{
                  imgList[0].location.slice(-2) == "入口"
                    ? "入场图片"
                    : "出场图片"
                }}
                <!-- <span>{{ handleTime(imgList[0].passTime) }}</span> -->
              </div>
              <div style="color: #38adff" @click="onImg(1)" v-if="!enter">
                收起
              </div>
              <div style="color: #38adff" @click="onImg(1)" v-if="enter">
                展开
              </div>
            </div>
            <div
              style="
                display: flex;
                height: 180px;
                justify-content: center;
                position: relative;
              "
              v-if="!enter"
            >
              <img
                style="
                  width: 90%;
                  height: 100%;
                  margin: 0 auto;
                  object-fit: cover;
                "
                :src="picUrl + imgList[0].imagePath"
                alt=""
                @click="previewImg(picUrl + imgList[0].imagePath)"
              />
              <div style="position: absolute; bottom: 10px; left: 30px">
                <div style="color: #fff; font-size: 13px">
                  {{ handleTime(imgList[0].passTime) }}
                </div>
                <div style="color: #fff; font-size: 13px">
                  {{ imgList[0].location }}
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="
              imgList.length > 0 &&
              (imgList[imgList.length - 1].location ===
                '峪见关山酒店门口出口' ||
                imgList[imgList.length - 1].location === '加气站出口')
            "
          >
            <div class="plic_list">
              <div>
                {{
                  imgList[imgList.length - 1].location.slice(-2) == "出口"
                    ? "出场图片"
                    : "入场图片"
                }}
                <!-- <span>{{
                  handleTime(imgList[imgList.length - 1].passTime)
                }}</span> -->
              </div>
              <div style="color: #38adff" @click="onImg(2)" v-if="!out">
                收起
              </div>
              <div style="color: #38adff" @click="onImg(2)" v-if="out">
                展开
              </div>
            </div>
            <div
              style="
                display: flex;
                height: 180px;
                justify-content: center;
                position: relative;
              "
              v-if="!out"
            >
              <img
                style="
                  width: 90%;
                  height: 100%;
                  margin: 0 auto;
                  object-fit: cover;
                "
                :src="picUrl + imgList[imgList.length - 1].imagePath"
                alt=""
                @click="
                  previewImg(picUrl + imgList[imgList.length - 1].imagePath)
                "
              />
              <div style="position: absolute; bottom: 10px; left: 30px">
                <div style="color: #fff; font-size: 13px">
                  {{ handleTime(imgList[imgList.length - 1].passTime) }}
                </div>
                <div style="color: #fff; font-size: 13px">
                  {{ imgList[imgList.length - 1].location }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!nums.id">
          <div v-if="nums.entryLocation">
            <div class="plic_list">
              <div>
                {{
                  nums.entryLocation.slice(-2) == "入口"
                    ? "入场图片"
                    : "出场图片"
                }}
                <!-- <span>{{ handleTime(nums.entryTime) }}</span> -->
              </div>
              <div style="color: #38adff" @click="onImg(1)" v-if="!enter">
                收起
              </div>
              <div style="color: #38adff" @click="onImg(1)" v-if="enter">
                展开
              </div>
            </div>
            <div
              style="
                display: flex;
                height: 180px;
                justify-content: center;
                position: relative;
              "
              v-if="!enter"
            >
              <img
                style="
                  width: 90%;
                  height: 100%;
                  margin: 0 auto;
                  object-fit: cover;
                "
                :src="picUrl + nums.entryImage"
                alt=""
                @click="previewImg(picUrl + nums.entryImage)"
              />
              <div style="position: absolute; bottom: 10px; left: 30px">
                <div style="color: #fff; font-size: 13px">
                  {{ handleTime(nums.entryTime) }}
                </div>
                <div style="color: #fff; font-size: 13px">
                  {{ nums.entryLocation }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="nums.exitLocation">
            <div class="plic_list">
              <div>
                {{
                  nums.exitLocation.slice(-2) == "出口"
                    ? "出场图片"
                    : "入场图片"
                }}
                <!-- <span>{{ handleTime(nums.exitTime) }}</span> -->
              </div>
              <div style="color: #38adff" @click="onImg(2)" v-if="!out">
                收起
              </div>
              <div style="color: #38adff" @click="onImg(2)" v-if="out">
                展开
              </div>
            </div>
            <div
              style="
                display: flex;
                height: 180px;
                justify-content: center;
                position: relative;
              "
              v-if="!out"
            >
              <img
                style="
                  width: 90%;
                  height: 100%;
                  margin: 0 auto;
                  object-fit: cover;
                "
                :src="picUrl + nums.exitImage"
                alt=""
                @click="previewImg(picUrl + nums.exitImage)"
              />
              <div style="position: absolute; bottom: 10px; left: 30px">
                <div style="color: #fff; font-size: 13px">
                  {{ handleTime(nums.exitTime) }}
                </div>
                <div style="color: #fff; font-size: 13px">
                  {{ nums.exitLocation }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="imgList.length > 0">
          <div class="plic_list">
            <div>途径点图片</div>
            <div style="color: #38adff" @click="onImg(3)" v-if="!way">收起</div>
            <div style="color: #38adff" @click="onImg(3)" v-if="way">展开</div>
          </div>
          <div style="display: flex; align-items: center" v-if="!way">
            <!-- <div
              style="flex: 1; height: 130px; display: flex; align-items: center"
            >
              <div
                style="
                  position: relative;
                  width: 47%;
                  height: 100%;
                  margin-right: 10px;
                "
                v-for="(item, index) in visibleImages"
                :key="index"
              >
                <img
                  style="width: 100%; height: 100%; object-fit: cover"
                  :src="picUrl + item.imagePath"
                  alt=""
                />
                <div style="position: absolute; bottom: 5px; left: 10px">
                  <div style="font-size: 13px; color: #fff">
                    {{ item.location }}
                  </div>
                  <div style="font-size: 13px; color: #fff; margin-top: 3px">
                    {{ handleTime(item.passTime) }}
                  </div>
                </div>
              </div>
            </div>
            <img
              v-if="imgList.length > 2"
              style="width: 30px; height: 30px"
              src="../assets/right.png"
              alt=""
              @click="onlistImg"
            /> -->

            <van-swipe
              :loop="false"
              :width="190"
              style="height: 130px"
              :show-indicators="false"
            >
              <van-swipe-item
                v-for="(item, index) in imgList"
                :key="index"
                style="width: 180px; margin-right: 10px; position: relative"
              >
                <img
                  style="width: 100%; height: 100%; object-fit: cover"
                  :src="picUrl + item.imagePath"
                  alt=""
                  @click="previewImg(imgList, index)"
                />
                <div style="position: absolute; bottom: 5px; left: 10px">
                  <div style="font-size: 13px; color: #fff">
                    {{ item.location }}
                  </div>
                  <div style="font-size: 13px; color: #fff; margin-top: 3px">
                    {{ handleTime(item.passTime) }}
                  </div>
                </div></van-swipe-item
              >
            </van-swipe>
          </div>
        </div>
      </div>
      <!-- 核实按钮 -->
      <div
        style="display: flex; justify-content: center; margin-top: 20px"
        v-if="nums.id"
      >
        <div
          style="
            width: 45%;
            background-color: #ff5b5b;
            height: 50px;
            color: #fff;
            font-size: 16px;
            font-weight: 500;
            border-radius: 5px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          "
          v-if="nums.verifyStatus == 1"
        >
          <div>已核实</div>
          <div v-if="nums.verifyContent" style="font-size: 14px">
            {{ nums.verifyContent }}
          </div>
        </div>
        <div
          style="
            width: 45%;
            background-color: #00d877;
            height: 50px;
            text-align: center;
            line-height: 50px;
            color: #fff;
            font-size: 16px;
            font-weight: 500;
            border-radius: 5px;
          "
          v-if="nums.verifyStatus == 0"
          @click="onVerify(nums.id)"
        >
          核实
        </div>
      </div>
    </div>
    <div
      v-if="carShow"
      style="
        text-align: center;
        height: 100px;
        line-height: 100px;
        font-size: 16px;
      "
    >
      暂无此车牌数据!
    </div>
    <!-- 数据列表 -->
    <div class="lists" v-if="historyNums.length > 0">
      <div
        class="list_li"
        v-for="(item, index) in historyNums"
        :key="index"
        @click="Hlist(item.id)"
      >
        <div class="li" style="text-align: left; width: 25%">
          {{ item.warningType }}
        </div>
        <div class="li">{{ handleTime(item.createTime) }}</div>
        <div class="li" style="text-align: right">
          {{ item.verifyStatus === 0 ? "未核实" : "已核实" }}
        </div>
      </div>
    </div>
    <div
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 20px;
      "
    >
      <div
        style="
          width: 120px;
          height: 30px;
          border-radius: 5px;
          background-color: #ccc;
          color: #fff;
          line-height: 30px;
          text-align: center;
          font-size: 15px;
          margin-right: 20px;
        "
        @click="onWhiteList"
      >
        添加临时白名单
      </div>
      <div
        style="
          width: 120px;
          height: 30px;
          border-radius: 5px;
          background-color: #ccc;
          color: #fff;
          line-height: 30px;
          text-align: center;
          font-size: 15px;
        "
        @click="onLongWhiteList"
        v-if="canAddLongWhitelist == 1"
      >
        添加长期白名单
      </div>
    </div>

    <div class="bot_title">版权所有：陕西关山草原旅游发展有限责任公司</div>
    <!-- 弹出层 -->
    <van-popup v-model="show" round position="bottom" class="popup">
      <div class="checkbox">
        <van-radio-group v-model="radio" class="checkbox">
          <van-radio name="道路拥挤导致超时">道路拥挤导致超时</van-radio>
          <van-radio name="已补票">已补票</van-radio>
        </van-radio-group>
      </div>
      <div class="hs" @click="getVerify">核实</div>
    </van-popup>
  </div>
</template>

<script>
import request from "@/api/index";
import carNums from "../../components/carNums.vue";
import { Dialog, Toast, ImagePreview } from "vant";

export default {
  // name: 'Home',
  components: {
    carNums,
  },
  data() {
    return {
      picUrl: "https://www.lxgscy.cn/vehicle/",
      actives: 1,
      enter: false, //入场
      out: false, //出场
      way: false, //途径
      cartype: 1,
      nums: {}, //数据
      imgList: [],
      parentData: "", //输入的车牌
      code: "", //授权返回的code
      openId: "",
      carShow: false, //是否有数据
      historyList: [], //历史搜索
      catnum: "", //传递的车牌
      currentIndex: 0,
      warningId: "",
      plateId: "",
      show: false,
      radio: "道路拥挤导致超时",
      historyNums: [], //历史预警
      canAddLongWhitelist: 0,
    };
  },
  created() {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code"); // 成功获取code
    // const nums = params.get("carNumber"); // 成功获取车牌
    const warningId = params.get("warningId") || this.$route.query.warningId; //获取主键id
    this.code = code ? code : "";
    this.warningId = warningId ? warningId : "";
    console.log(this.$route.query.warningId);

    // this.parentData = nums ? nums : "";
    // if (nums) {
    //   if (nums.length == 7) {
    //     this.cartype = 1;
    //     this.actives = 1;
    //   }
    //   if (nums.length == 8) {
    //     this.cartype = 2;
    //     this.actives = 2;
    //   }
    // }

    this.getopenid();
    
  },
  computed: {
    // 新增：计算当前应该显示的两条数据(途径点图片显示)
    visibleImages() {
      return this.imgList.slice(this.currentIndex, this.currentIndex + 2);
    },
  },
  mounted() {},
  methods: {
    //判断是否有权限添加长期白名单
    async onLongTerm() {
      const open = this.openId;
      const res = await request.isAddLongWhite(open);
      this.canAddLongWhitelist = res.data.data.canAddLongWhitelist;
    },
    //图片预览
    previewImg(item, index = 0) {
      if (Array.isArray(item)) {
        const imagePaths = [];

        item.forEach((it) => {
          if (it?.imagePath) {
            // 使用可选链操作符更安全
            imagePaths.push(this.picUrl + it.imagePath);
          }
        });

        console.log(imagePaths);
        ImagePreview({
          images: imagePaths, // 所有图片
          startPosition: index, // 关键点：从点击的索引开始展示
        }); // 注意这里移除了多余的数组包裹
      } else {
        ImagePreview([`${item}`]);
      }
    },
    //处理时间
    handleTime(time) {
      if (time) {
        return time.includes("T")
          ? time.split("T")[0] + " " + time.split("T")[1]
          : time;
      }
      // return time;
    },

    //获取openid
    async getopenid() {
      const opens = localStorage.getItem("openid");
      if (opens) {
        this.openId = opens;
        if (this.warningId) {
          this.getWarning();
        } else {
          this.onbutton();
        }
        this.getHistory();
        this.onLongTerm();
      } else {
        if (this.code) {
          const res = await request.wxcode(this.code);
          localStorage.setItem("openid", res.data.openId);
          this.openId = res.data.openId;
          if (this.warningId) {
            this.getWarning();
          } else {
            this.onbutton();
          }
          this.getHistory();
          this.onLongTerm();
        } else {
          this.$router.push({
            path: "/login",
            query: {
              url: window.location.href,
            },
          });
        }
      }
    },
    //携带数据请求
    async getWarning() {
      const data = {
        id: this.warningId,
        openid: this.openId,
      };
      if (!this.warningId) return;
      const res = await request.getById(data);
      console.log(res, "435");
      if (res.data.code == 403) {
        Dialog.alert({
          message: res.data.message,
        }).then(() => {
          // on close
        });
        return;
      }
      if (res.data.code == 404) {
        Toast(`${res.data.message}`);
        this.carShow = true;
        this.imgList = [];
        this.nums = {};
      }
      if (res.data.message == "success") {
        if (res.data.data.length > 0) {
          this.carShow = false;
          this.imgList =
            res.data.data.length > 0
              ? res.data.data[0].vehicleTrack
                ? JSON.parse(res.data.data[0].vehicleTrack)
                : []
              : [];
          this.nums = res.data.data.length > 0 ? res.data.data[0] : {};
          this.parentData = res.data.data[0].plateNumber;
        } else {
          this.carShow = true;
          this.imgList = [];
          this.nums = {};
        }
        this.getHistory();
        this.onHistoryList();
      }
    },

    async onbutton() {
      const num = {
        plateNumber: this.parentData,
        openId: this.openId,
      };
      if (!num.plateNumber) {
        // this.carShow = true;
        return;
      }
      const res = await request.list(num);
      if (res.data.code == 403) {
        Dialog.alert({
          message: res.data.message,
        }).then(() => {
          // on close
        });
        return;
      }
      if (res.data.code == 404) {
        Toast(`${res.data.message}`);
        this.carShow = true;
        this.imgList = [];
        this.nums = {};
      }
      if (res.data.message == "success") {
        if (res.data.data.length > 0) {
          this.carShow = false;
          this.imgList =
            res.data.data.length > 0
              ? res.data.data[0].vehicleTrack
                ? JSON.parse(res.data.data[0].vehicleTrack)
                : []
              : [];
          this.nums = res.data.data.length > 0 ? res.data.data[0] : {};
          this.parentData = res.data.data[0].plateNumber;
        } else {
          this.carShow = true;
          this.imgList = [];
          this.nums = {};
        }
        this.getHistory();
        this.onHistoryList();
      }
    },
    //切换车牌类型
    oncarShow(index) {
      this.actives = index;
      this.cartype = index;
    },
    //点击收起/展开
    onImg(index) {
      if (index == 1) {
        this.enter = !this.enter;
      }
      if (index == 2) {
        this.out = !this.out;
      }
      if (index == 3) {
        this.way = !this.way;
      }
    },
    //查询
    onquery() {
      if (!this.parentData) {
        Toast("请输入车牌");
        return;
      }
      if (this.parentData.length < 7) {
        Toast("请输入完整车牌");
        return;
      }
      this.onbutton();
    },
    handleChildData(data) {
      this.parentData = data;
    },
    //核实按钮
    async onVerify(id) {
      console.log(id);
      this.plateId = id;
      this.show = true;
    },
    async getVerify() {
      const num = {
        plateNumber: this.parentData,
        openId: this.openId,
        verifyContent: this.radio,
        id: this.plateId,
      };
      console.log(num);
      const res = await request.verify(num);
      console.log(res, res.data.data);
      if (res.data.message == "success") {
        this.show = false;
        Toast("核实成功");
        this.onbutton();
      }
    },
    //历史记录
    async getHistory() {
      const nums = this.openId;
      const res = await request.history(nums);
      this.historyList = res.data.data;
    },
    //删除历史记录
    async onDelete() {
      Dialog.confirm({
        // title: '标题',
        message: "确定要删除历史记录吗？",
      })
        .then(async () => {
          // on confirm
          const nums = this.openId;
          const res = await request.deleteHistory(nums);
          if (res.data.data == 1) {
            this.historyList = [];
            Toast("删除成功");
            this.onbutton();
          }
        })
        .catch(() => {
          // on cancel
        });
    },
    //点击历史列表
    onlist(nums) {
      this.parentData = nums;
      console.log(nums, nums.length);
      if (nums.length == 7) {
        this.cartype = 1;
        this.actives = 1;
      }
      if (nums.length == 8) {
        this.cartype = 2;
        this.actives = 2;
      }

      this.catnum = nums;
      this.onbutton();
    },
    //点击加一张图
    onlistImg() {
      if (this.currentIndex + 2 < this.imgList.length) {
        this.currentIndex++;
      }
    },
    //点击临时白名单
    onWhiteList() {
      this.$router.push({
        path: "/whiteList",
      });
    },
    //添加长期白名单
    onLongWhiteList() {
      this.$router.push({
        path: "/longTerm",
      });
    },
    //查询历史记录
    async onHistoryList() {
      const data = {
        openid: this.openId,
        plateNumber: this.parentData,
        entryTime: this.handleTime(this.nums.createTime),
      };
      console.log(data);
      if (!this.nums.entryTime) return;
      const res = await request.getHistory(data);
      console.log(res.data.data);
      this.historyNums = res.data.data;
    },
    Hlist(id) {
      this.warningId = id;
      this.getWarning();
    },
  },
};
</script>
<style  scoped>
@import "Home.css";
</style>
